/* Pertegaz product-image lightbox — fit view + extra detail zoom. */
(function () {
  if (window.__pzLightboxInit) return;
  window.__pzLightboxInit = true;

  var ZOOM = 1.6;           // extra-zoom scale (level 3)
  var slides = [];          // [{mid, full, thumb, alt}]
  var index = 0;
  var zoomed = false;
  var fitRect = null;       // image rect captured in fit mode (for pan mapping)

  // move to <body> so position:fixed is viewport-relative (a transformed section ancestor
  // would otherwise trap it — same fix as the footer/location drawer)
  function relocate() {
    var d = document.querySelector('[data-pz-lightbox]');
    if (d && d.parentNode !== document.body) document.body.appendChild(d);
  }
  if (document.readyState !== 'loading') relocate();
  else document.addEventListener('DOMContentLoaded', relocate);

  function lb() { return document.querySelector('[data-pz-lightbox]'); }
  function q(sel) { var d = lb(); return d ? d.querySelector(sel) : null; }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  // ---- build the slide model from the rendered data spans ----
  function buildSlides() {
    var d = lb(); if (!d) return;
    slides = Array.prototype.map.call(d.querySelectorAll('[data-pz-slide]'), function (s) {
      return { mid: s.getAttribute('data-mid'), full: s.getAttribute('data-full'), thumb: s.getAttribute('data-thumb'), alt: s.getAttribute('data-alt') || '' };
    });
    var rail = q('[data-pz-lb-thumbs]');
    if (rail && !rail.childElementCount) {
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pz-lightbox__thumb';
        b.setAttribute('data-pz-lb-thumb', i);
        var im = document.createElement('img');
        im.src = s.thumb; im.alt = s.alt; im.loading = 'lazy';
        b.appendChild(im);
        rail.appendChild(b);
      });
    }
    var nav = slides.length > 1;
    var p = q('[data-pz-lb-prev]'), n = q('[data-pz-lb-next]');
    if (p) p.hidden = !nav;
    if (n) n.hidden = !nav;
    if (rail) rail.style.display = nav ? '' : 'none';
  }

  function render() {
    var img = q('[data-pz-lb-img]'); if (!img || !slides[index]) return;
    exitZoom();
    img.src = slides[index].full;
    img.alt = slides[index].alt;
    var d = lb();
    d.querySelectorAll('[data-pz-lb-thumb]').forEach(function (t) {
      var on = +t.getAttribute('data-pz-lb-thumb') === index;
      t.classList.toggle('is-active', on);
      if (on) t.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
  }

  function open(startMid) {
    relocate();
    var d = lb(); if (!d) return;
    if (!slides.length) buildSlides();
    var i = slides.findIndex(function (s) { return s.mid === String(startMid); });
    index = i >= 0 ? i : 0;
    d.hidden = false; d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    render();
  }
  function close() {
    var d = lb(); if (!d) return;
    exitZoom();
    d.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () { d.hidden = true; d.setAttribute('aria-hidden', 'true'); }, 300);
  }
  function step(dir) {
    if (!slides.length) return;
    index = (index + dir + slides.length) % slides.length;
    render();
  }

  // ---- extra zoom (level 3) ----
  function enterZoom(clientX, clientY) {
    var d = lb(), img = q('[data-pz-lb-img]'); if (!d || !img) return;
    fitRect = img.getBoundingClientRect();   // capture BEFORE scaling
    zoomed = true;
    d.classList.add('is-zoomed');
    pan(clientX, clientY);
    img.style.transform = 'scale(' + ZOOM + ')';
  }
  function exitZoom() {
    var d = lb(), img = q('[data-pz-lb-img]'); if (!d || !img) return;
    zoomed = false;
    d.classList.remove('is-zoomed');
    img.style.transform = '';
    img.style.transformOrigin = '';
  }
  function pan(clientX, clientY) {
    var img = q('[data-pz-lb-img]'); if (!img || !fitRect || fitRect.width === 0) return;
    var x = clamp((clientX - fitRect.left) / fitRect.width, 0, 1);
    var y = clamp((clientY - fitRect.top) / fitRect.height, 0, 1);
    img.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%';
  }

  // ---- intercept PDP gallery image clicks (before Dawn's modal opens) ----
  document.addEventListener('click', function (e) {
    var viewer = e.target.closest('.pz-pdp .product__media-list');
    if (!viewer) return;
    var item = e.target.closest('.product__media-item');
    if (!item) return;
    // images only — let Dawn handle video / 3d model
    if (item.querySelector('deferred-media, product-model')) return;
    var img = item.querySelector('img');
    if (!img) return;
    var toggle = item.querySelector('.product__media-toggle');
    var mid = toggle ? toggle.getAttribute('data-media-id') : null;
    if (!mid) return;
    e.preventDefault();
    e.stopPropagation();
    open(mid);
  }, true);

  // ---- lightbox interactions (delegated) ----
  document.addEventListener('click', function (e) {
    var d = lb(); if (!d || d.hidden) return;
    if (e.target.closest('[data-pz-lb-close]')) { close(); return; }
    if (e.target.closest('[data-pz-lb-prev]')) { step(-1); return; }
    if (e.target.closest('[data-pz-lb-next]')) { step(1); return; }
    var thumb = e.target.closest('[data-pz-lb-thumb]');
    if (thumb) { index = +thumb.getAttribute('data-pz-lb-thumb'); render(); return; }
    // stage clicks toggle the extra zoom
    if (e.target.closest('[data-pz-lb-stage]')) {
      if (zoomed) { exitZoom(); }
      else if (e.target.closest('[data-pz-lb-img]')) { enterZoom(e.clientX, e.clientY); }
    }
  });

  // pan while zoomed (mouse + touch)
  document.addEventListener('mousemove', function (e) {
    if (zoomed) pan(e.clientX, e.clientY);
  });
  document.addEventListener('touchmove', function (e) {
    if (!zoomed) return;
    var t = e.touches[0]; if (t) { pan(t.clientX, t.clientY); e.preventDefault(); }
  }, { passive: false });

  // keyboard
  document.addEventListener('keydown', function (e) {
    var d = lb(); if (!d || d.hidden) return;
    if (e.key === 'Escape') { zoomed ? exitZoom() : close(); }
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  });
})();
